import { render, staticRenderFns } from "./ApprovalHistory.vue?vue&type=template&id=ba022e06&"
import script from "./ApprovalHistory.vue?vue&type=script&lang=js&"
export * from "./ApprovalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports